// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".row[data-v-76e265da] {\n  display: table;\n  table-layout: fixed;\n  word-wrap: break-word;\n  width: 100%;\n}", ""]);
// Exports
module.exports = exports;
